import { IHeaderNavigationMap } from "@sundae/ui-toolkit/dist/types/components/organisms/Header/Header";
import { TFunction } from "i18next";

import { paths, TLocationGenerics } from "../pages/routes";
import { ExchangeMode } from "../stores";
import { featureIsEnabled } from "../utils/features.utils";

export const getMenuItems = (isWalletConnected: boolean, t: TFunction): IHeaderNavigationMap[] => [
  {
    title: isWalletConnected ? t("paths.root.connected") : t("paths.root.disconnected"),
    to: paths.root,
    variant: "normal",
    search: undefined,
  },
  {
    title: t("paths.exchange.root"),
    to: paths.exchange,
    search: (search: TLocationGenerics["Search"]) => {
      return {
        ...search,
        mode: ExchangeMode.swap,
      };
    },
  },
  {
    title: t("paths.liquidity.root"),
    to: paths.liquidity.root,
    search: undefined,
  },
  ...(featureIsEnabled("tasteTest")
    ? [
        {
          title: t("paths.tasteTest"),
          to: paths.tasteTest.root,
        },
      ]
    : []),
  {
    title: t("paths.yieldFarming"),
    to: paths.yieldFarming,
  },
  {
    title: t("paths.orders"),
    to: paths.orders,
  },
];
